module.exports = __webpack_public_path__ + "img/smooth-pk-chart.f95bf52a.png";